import { render, staticRenderFns } from "./ComplexionsView.vue?vue&type=template&id=5492b13b&scoped=true"
import script from "./ComplexionsView.vue?vue&type=script&lang=js"
export * from "./ComplexionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5492b13b",
  null
  
)

export default component.exports